<template>
  <li class="no-icon">
    Test...
  </li>
</template>

<script>
import flowMixin from "@/components/pessoa/components/include/historico/flowMixin"

export default {
  name: "FlowSimple",
  mixins: [flowMixin]
}
</script>
